import { inject, injectable } from "inversify";
import { ICPLStandardDescriptionsClient, StandardDescriptionModel } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IStandardDescriptionsService {
  getStandardDescriptions(): Promise<StandardDescriptionModel[]>;
}

@injectable()
export class StandardDescriptionService implements IStandardDescriptionsService {
  @inject(SERVICE_TYPES.CPLStandardDescriptionsClient)
  cplStandardDescriptionsClient!: ICPLStandardDescriptionsClient;

  async getStandardDescriptions(): Promise<StandardDescriptionModel[]> {
    return this.cplStandardDescriptionsClient.getStandardDescriptions();
  }
}
